import { ContextData } from '@dynamika-shared/types/clinicalTrialContext';
import { omit } from 'lodash';
import { FlatLabels, FlatVisits } from './clinicalTrialContext.types';
import { UserAffiliationType } from '@dynamika-shared/types/auth';

export const makeFlatAllLabels = (
  labelGroups: ContextData['configuration']['labelGroups']
): FlatLabels => {
  const flatLabels: FlatLabels = {};
  for (const group of labelGroups || []) {
    if (!group?.labels) continue;

    for (const label of group?.labels || []) {
      if (!label?.id) continue;

      flatLabels[label?.id] = {
        id: label?.id,
        name: label?.name,
        dataType: label.dataType,
        modalityName: group?.modalityName,
        inputDataType: label.inputDataType,
      };
    }
  }

  return flatLabels;
};

export const makeFlatVisits = (
  cohorts: ContextData['configuration']['cohorts'],
  flatAllLabels: FlatLabels
): FlatVisits => {
  const flatVisits: FlatVisits = {};
  for (const cohort of cohorts || []) {
    if (!cohort?.visits) continue;

    for (const visit of cohort?.visits || []) {
      if (!visit?.id) continue;

      flatVisits[visit?.id] = {
        id: visit?.id,
        name: visit?.name,
        daysFromBaseline: visit?.daysFromBaseline,
        cohort: omit(cohort, 'visits'),
        labels: visit?.labels?.reduce((acc, labelId) => {
          acc[labelId] = flatAllLabels[labelId];
          return acc;
        }, {} as FlatLabels),
        questionnaires: visit.questionnaires,
      };
    }
  }

  return flatVisits;
};

export const makeAffiliatedSiteList = (
  sites: ContextData['configuration']['sites'],
  affiliations: ContextData['affiliations']
) => {
  return sites?.filter(item =>
    affiliations?.some(
      ({ affiliationType, referenceId }) =>
        affiliationType === UserAffiliationType.SITE && referenceId === item.id
    )
  );
};
